import { ApiProfile } from '~/passporter-services/profile/apiTypes'
import { TextWallPinData } from '~/models/WallPin'
import { ApiLink } from '~/passporter-services/link/apiTypes'
import { ApiMedia } from '~/passporter-services/media/apitype'

type ApiWallPin = ApiTextWallPin | ApiLinkWallPin | ApiMediaWallPin

enum API_WALL_PIN_TYPE {
	TEXT = 'text',
	LINK = 'link',
	MEDIA = 'image',
}

type ApiTextWallPin = ApiBaseWallPin & {
	type: API_WALL_PIN_TYPE.TEXT
	data: TextWallPinData
}

type ApiLinkWallPin = ApiBaseWallPin & {
	type: API_WALL_PIN_TYPE.LINK
	data: ApiLink
}

type ApiMediaWallPinData = {
	id: string | null
	media?: ApiMedia
}

type ApiMediaWallPin = ApiBaseWallPin & {
	type: API_WALL_PIN_TYPE.MEDIA
	data: ApiMediaWallPinData
}

type ApiBaseWallPin = {
	id?: string
	type: API_WALL_PIN_TYPE
	owner?: ApiProfile
	created?: Date
	data: unknown
}

export {
	ApiWallPin,
	API_WALL_PIN_TYPE,
	ApiTextWallPin,
	ApiBaseWallPin,
	ApiLinkWallPin,
	ApiMediaWallPin,
	ApiMediaWallPinData,
}
